import React, { useContext, useState, useEffect } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { ElectricityForcastedGraph } from '../../../components/EnergyCostBreakdown/ElectricityForcastedGraph/ElectricityForcastedGraph';
import styled from 'styled-components';
import { Row, Col, Card } from 'reactstrap';
import { FirebaseContext2 } from '../../../../../firebase';

const Topic = styled.h5`
  margin: 0px;
  float: right;
`;

const Header = styled.h4`
  margin: 0px;
`;

const EnergySavingRecommendation = () => {
  const firebase = useContext(FirebaseContext2);
  const [energySaving, setEnergySaving] = useState(null);

  function fetchData(didMount) {
    const main_path = 'hotel/mintel/energy/energy_saving_recommendation';

    if (didMount) {
      firebase.db.ref(main_path).off('value');
    } else {
      firebase.db.ref(main_path).on('value', function (snap) {
        let capt = snap.val();
        setEnergySaving(capt);
      });
    }
  }

  useEffect(() => {
    fetchData(false);
    return () => fetchData(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const plotData = {
    series: [
      {
        name: 'Your consumption',
        data: energySaving !== null ? Object.values(energySaving.power_consumption) : [],
        type: 'area',
      },
      {
        name: 'Altotech Solution',
        data: energySaving !== null ? Object.values(energySaving.alto_saving_kw) : [],
        type: 'area',
      },
    ],
    options: {
      chart: {
        type: 'area',
        stacked: false,
        height: 350,
        zoom: {
          enabled: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      markers: {
        size: 0,
      },
      fill: {
        type: 'area',
        gradient: {
          shadeIntensity: 1,
          inverseColors: false,
          opacityFrom: 0.45,
          opacityTo: 0.05,
          stops: [20, 100, 100, 100],
        },
      },
      yaxis: {
        tickAmount: 9,
        title: {
          text: '(kW)',
        },
        formatter: function (val) {
          return val.toFixed(2);
        },
      },
      xaxis: {
        type: 'category',
        categories: energySaving !== null ? Object.keys(energySaving.power_consumption) : [],
      },
      title: {
        text: 'Irregular Data in Time Series',
        align: 'left',
        offsetX: 14,
      },
      tooltip: {
        shared: true,
      },
      legend: {
        position: 'top',
        horizontalAlign: 'right',
        offsetX: -10,
      },
    },
  };
  return (
    <div style={{marginTop:'20px'}}>
      <Col lg="12" sm="12">
        <Card>
          <Row>
            <Col lg="12" md="12" sm="12">
              <ElectricityForcastedGraph
                title={'Energy saving recommendation'}
                options={plotData.options}
                series={plotData.series}
              />
            </Col>
          </Row>
          <div style={{ margin: '20px', marginLeft: '40px' }}>
            <Row>
              <Header>Alto Tech Solution</Header>
            </Row>

            <Row>
              <Col lg="3">
                <Topic>Investment :</Topic>
              </Col>
              <Col lg="3">
                <p>
                  {energySaving !== null && energySaving.finance.investment.value}{' '}
                  {energySaving !== null && energySaving.finance.investment.unit}
                </p>
              </Col>
              <Col lg="3">
                <Topic>Investment Score :</Topic>
              </Col>
              <Col lg="3">
                <p>{energySaving !== null && energySaving.finance.investment_score}</p>
              </Col>
            </Row>
            <Row>
              <Col lg="3">
                <Topic>Save Monthly :</Topic>
              </Col>
              <Col lg="3">
                <p>
                  {energySaving !== null && energySaving.finance.save_monthly.value}{' '}
                  {energySaving !== null && energySaving.finance.save_monthly.unit}
                </p>
              </Col>
              <Col lg="3">
                <Topic>Save Yearly :</Topic>
              </Col>
              <Col lg="3">
                <p>
                  {energySaving !== null && energySaving.finance.save_yearly.value}{' '}
                  {energySaving !== null && energySaving.finance.save_yearly.unit}
                </p>
              </Col>
            </Row>
            <Row>
              <Col lg="3">
                <Topic>Payback :</Topic>
              </Col>
              <Col lg="3">
                <p>
                  {energySaving !== null && energySaving.finance.payback.value}{' '}
                  {energySaving !== null && energySaving.finance.payback.unit}
                </p>
              </Col>
            </Row>
          </div>
        </Card>
      </Col>
    </div>
  );
};

export { EnergySavingRecommendation };
